module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-edit-tenants/kiosk-edit-tenants.component.css
// module id = ./src/app/kiosk-edit-tenants/kiosk-edit-tenants.component.css
// module chunks = main